import { render, staticRenderFns } from "./ProductItems.vue?vue&type=template&id=499e9366&"
import script from "./ProductItems.vue?vue&type=script&lang=js&"
export * from "./ProductItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports